import {GlobalMessage, AppUiState} from '@nw/ui-core-shared/store/domain';
import {AppUiActions} from '@nw/ui-core-shared/store/actions';
import {Action} from '@ngrx/store';

export const INITAL_MESSAGE_STATE: GlobalMessage = {
  type: 'info'
};

export const INITIAL_APP_UI_STATE = {
  isFixedHeader : false,
  isScrollingUp : false,
  globalError   :   '',
  isMobileDevice: false,
  isiOSDevice   : false
};



export function appUiStateReducer(state: AppUiState = INITIAL_APP_UI_STATE, action: Action): AppUiState {

  switch (action.type)  {

    case AppUiActions.GLOBAL_MESSAGE_HANDLER:
      return updateState(state, action, 'message');

    case AppUiActions.GLOBAL_MESSAGE_REMOVE_HANDLER:
      return updateState(state, action, 'message');

    case AppUiActions.SCREEN_RESIZE_HANDLER:
      return updateState(state, action, 'screenSize');

    case AppUiActions.SET_FIXED_HEADER:
      return updateState(state, action, 'isFixedHeader');

    case AppUiActions.SET_SCROLLING_DIRECTION:
      return updateState(state, action, 'isScrollingUp');

    case AppUiActions.GLOBAL_ERROR_HANDLER:
      return updateState(state, action, 'globalError');

    case AppUiActions.GLOBAL_ERROR_REMOVE_HANDLER:
      return updateState(state, action, 'globalError');

    case AppUiActions.SET_MOBILE_DEVICE:
      return updateState(state, action, 'isMobileDevice');

    case AppUiActions.SET_IOS_DEVICE:
      return updateState(state, action, 'isiOSDevice');

    default:
      return state;

  }

}


function updateState(state: AppUiState, action: Action, key: string) {
  const newState = Object.assign({}, state);
  newState[key] = action.payload;
  return newState;
}





// WEBPACK FOOTER //
// ./src/main/angular/app/main-state/reducers/app-ui.reducer.ts